class Mutex {
  constructor() {
    this.locked = false;
    this.queue = [];
  }

  async lock() {
    return new Promise((resolve) => {
      const acquireLock = async () => {
        if (!this.locked) {
          this.locked = true;
          resolve();
        } else {
          this.queue.push(acquireLock);
        }
      };
      acquireLock();
    });
  }

  unlock() {
    if (this.queue.length > 0) {
      const nextLock = this.queue.shift();
      nextLock();
    } else {
      this.locked = false;
    }
  }
}

export default Mutex;
